import { jsx } from "panel";
import { ContextPanelEl } from "common/widgets/context-panel";
import { Directions, PositioningStrategy } from "../drop-menu/types";
import { DropMenuEl } from "../drop-menu";
import { SectionEl, SectionRowEl } from "./section";
import { SectionItemEl, SectionItemSubMenuEl } from "./section/item";
const EmptySearchResult = ({ message }) => /* @__PURE__ */ jsx("ul", {
  sel: ".screen-options-list"
}, /* @__PURE__ */ jsx("li", {
  sel: ".list-option.list-empty"
}, /* @__PURE__ */ jsx("div", {
  sel: ".option-label"
}, message)));
const SectionList = ({ comp }) => {
  const sections = comp.helpers.getDisplaySections();
  const sectionsHint = comp.attr(`sections-hint`);
  const searchFilter = comp.attr(`search-filter`);
  const isMultiple = comp.attr(`multiple`);
  const isExperimental = comp.attr(`experimental-positioning`);
  const alignAllText = comp.attr(`align-all-text`) && sections.some((section) => section.iconRenderer || section.items.some((item) => {
    var _a;
    return (_a = item.wrapped) == null ? void 0 : _a.iconRenderer;
  }));
  const showMatches = !comp.attr(`disable-search-filter-matching-parts`);
  const { focusedItemIndex, isPillFocused, fullyShownSections } = comp.state;
  const { contextPanelTransform } = comp;
  if (sections.length) {
    return /* @__PURE__ */ jsx(null, null, sectionsHint && /* @__PURE__ */ jsx("div", {
      sel: ".sections-hint"
    }, sectionsHint), sections.map((section, idx) => /* @__PURE__ */ jsx(null, null, idx > 0 && !section.hideTopDivider && /* @__PURE__ */ jsx("div", {
      sel: ".section-divider"
    }), /* @__PURE__ */ jsx(SectionEl, {
      section,
      hideSectionTitle: section.isHidden && !fullyShownSections[section.wrappedSectionIndex],
      isExperimental
    }, section.items.map((item) => {
      var _a, _b;
      const sectionItem = item.wrapped;
      const isFocused = focusedItemIndex === item.index;
      const isItemSubMenuOpen = comp.isSubItemsOpen(item.index);
      return /* @__PURE__ */ jsx(SectionRowEl, {
        item,
        isFocused,
        isMultiple,
        isExperimental,
        contextPanelTransform,
        onClick: comp.helpers.handleClickItem,
        onMouseEnter: comp.helpers.handleMouseenterItem,
        onMouseLeave: comp.helpers.handleMouseleaveItem
      }, /* @__PURE__ */ jsx(SectionItemEl, {
        item,
        isPillFocused,
        isMultiple,
        isFocused,
        alignAllText,
        showMatches,
        isExperimental,
        displayAllSelectOne: section.displayAllSelectOne,
        actionsRenderer: (_a = sectionItem.actionsRenderer) != null ? _a : section.actionsRenderer,
        iconRenderer: (_b = sectionItem.iconRenderer) != null ? _b : section.iconRenderer,
        onActionClick: comp.helpers.handleClickPill,
        onActionMouseEnter: comp.helpers.handleMouseenterPill,
        onActionMouseLeave: comp.helpers.handleMouseleavePill
      }), isItemSubMenuOpen && (sectionItem.subMenuRenderer ? sectionItem.subMenuRenderer((selectedValue) => {
        const itemClickEvent = comp.getClickItemEvent({
          item: {
            ...item,
            wrapped: {
              ...item.wrapped,
              value: selectedValue
            }
          },
          modifierKeys: null
        });
        comp.helpers.handleSubItemsClickItem(itemClickEvent);
      }) : /* @__PURE__ */ jsx(SectionItemSubMenuEl, {
        sections: sectionItem.subSections,
        alignAllText: comp.attr(`align-all-text`),
        isMultiple,
        contextPanelTransform,
        keydownProxyEl: comp.keydownProxyEl || comp,
        onNavigateBack: comp.helpers.handleSubItemsNavigateBack,
        onClickItem: comp.helpers.handleSubItemsClickItem,
        onFocusItem: comp.helpers.propagateEvent
      })));
    })))));
  }
  if (searchFilter) {
    return /* @__PURE__ */ jsx(EmptySearchResult, {
      message: comp.attr(`empty-search-results-message`)
    });
  }
  return /* @__PURE__ */ jsx(EmptySearchResult, {
    message: comp.attr(`empty-message`)
  });
};
export function template() {
  const { tooltipData } = this.state;
  const hasContextPanelContentSlot = this.helpers.hasSlot(`context-panel-content`);
  return /* @__PURE__ */ jsx("div", {
    sel: ".items-menu",
    hook: { postpatch: this.helpers.handlePostPatch },
    class: {
      [`${this.attr(`theme`)}-theme`]: true,
      "disable-first-item-padding": this.attr(`disable-first-item-padding`)
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".screen-list-container",
    on: {
      scroll: this.helpers.handleScroll
    },
    hook: {
      insert: ({ elm }) => this.handleInsertScreenListContainer(elm)
    }
  }, /* @__PURE__ */ jsx(SectionList, {
    comp: this
  })), tooltipData && /* @__PURE__ */ jsx(ContextPanelEl, {
    attrs: {
      elref: `contextPanel`,
      "tooltip-data": tooltipData
    },
    props: {
      tooltipPositionParentElement: this.contextPanelPositionParentElement
    }
  }), hasContextPanelContentSlot && /* @__PURE__ */ jsx(DropMenuEl, {
    attrs: {
      direction: Directions.Right,
      offset: -8,
      skidding: 72,
      open: true,
      "position-strategy": PositioningStrategy.Absolute
    },
    props: {
      positionParent: this.contextPanelPositionParentElement
    }
  }, /* @__PURE__ */ jsx("slot", {
    attrs: { name: `context-panel-content` }
  })));
}
